export default "__VITE_ASSET__DEFfYcwN__"